import Sentry from "@similarweb/sentry-logger";

import { swSettings } from "app/common/services/swSettings";
import { PreferencesService } from "app/services/preferences/preferencesService";
import { GrowthbookService } from "app/services/trackingServices/GrowthBookService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { ParamExperimentRoutingOptions } from "./types";
import { cleanUrlParams, safeSessionGetBoolean, safeSessionRemove, safeSessionSet } from "./utils";

export function routeOnParamExperiment(
    urlParams: URLSearchParams,
    {
        triggerParam,
        isAllowed,
        paramsToDelete = [],
        experiment,
        preferenceKey,
        skipWhenPreferenceFalse = true,
        fallback,
        resolveTarget,
        replaceUrl,
    }: ParamExperimentRoutingOptions,
): string | undefined | Promise<any> {
    if (!urlParams.has(triggerParam)) {
        // @ts-ignore FIXME: strict migration - fallback is optional string but proNavigator.go expects StateOrName — go() handles undefined at runtime by tracking it to Sentry
        return proNavigator.go(fallback);
    }

    if (!isAllowed) {
        cleanUrlParams(urlParams, [triggerParam, ...paramsToDelete], replaceUrl);
        // @ts-ignore FIXME: strict migration - fallback is optional string but proNavigator.go expects StateOrName — go() handles undefined at runtime by tracking it to Sentry
        return proNavigator.go(fallback);
    }

    if (experiment?.type === "isOn") {
        const gb = GrowthbookService?.growthbookInstance;

        const enabled = !!gb?.isOn?.(experiment.testName);

        if (!enabled) {
            cleanUrlParams(urlParams, [triggerParam, ...paramsToDelete], replaceUrl);
            // @ts-ignore FIXME: strict migration - fallback is optional string but proNavigator.go expects StateOrName — go() handles undefined at runtime by tracking it to Sentry
            return proNavigator.go(fallback);
        }
    }

    if (preferenceKey) {
        const volatileFlag = safeSessionGetBoolean(preferenceKey);

        if (volatileFlag === true) {
            cleanUrlParams(urlParams, [triggerParam, ...paramsToDelete], replaceUrl);
            safeSessionRemove(preferenceKey);

            // @ts-ignore FIXME: strict migration - fallback is optional string but proNavigator.go expects StateOrName — go() handles undefined at runtime by tracking it to Sentry
            return proNavigator.go(fallback);
        }

        let prefValue: unknown;

        try {
            prefValue = PreferencesService.get(preferenceKey);
        } catch {
            prefValue = undefined;
        }

        if (skipWhenPreferenceFalse && prefValue === false) {
            cleanUrlParams(urlParams, [triggerParam, ...paramsToDelete], replaceUrl);
            // @ts-ignore FIXME: strict migration - fallback is optional string but proNavigator.go expects StateOrName — go() handles undefined at runtime by tracking it to Sentry
            return proNavigator.go(fallback);
        }

        safeSessionSet(preferenceKey, "true");

        try {
            void PreferencesService.add({ [preferenceKey]: true });
        } catch (error) {
            Sentry.errorTracker({
                message: "Error in routeOnParamExperiment, PreferencesService is not available",
                e: error,
                level: "error",
            });
        }
    }

    cleanUrlParams(urlParams, [triggerParam, ...paramsToDelete], replaceUrl);

    return resolveTarget?.({ swSettings, urlParams }) ?? undefined;
}
